import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import type { GlossarTerm } from "@/utils/glossarData";

interface GlossarCardProps {
  term: GlossarTerm;
}

const categoryLabels = {
  bedrohungen: "Cyber-Bedrohungen",
  compliance: "Compliance & Recht",
  sicherheit: "Technische Sicherheit",
  medizin: "Medizin-IT",
  incident: "Incident Response"
};

const categoryColors = {
  bedrohungen: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-200 dark:border-red-800",
  compliance: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-200 dark:border-blue-800",
  sicherheit: "bg-green-500/10 text-green-700 dark:text-green-400 border-green-200 dark:border-green-800",
  medizin: "bg-purple-500/10 text-purple-700 dark:text-purple-400 border-purple-200 dark:border-purple-800",
  incident: "bg-orange-500/10 text-orange-700 dark:text-orange-400 border-orange-200 dark:border-orange-800"
};

export const GlossarCard = ({ term }: GlossarCardProps) => {
  return (
    <Link to={`/glossar/${term.slug}`}>
      <Card className="group hover:shadow-lg transition-all duration-300 hover:border-primary/50 h-full">
        <CardHeader>
          <div className="flex items-start justify-between gap-3 mb-2">
            <CardTitle className="text-xl group-hover:text-primary transition-colors">
              {term.name}
            </CardTitle>
            <ArrowRight className="h-5 w-5 text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all flex-shrink-0 mt-1" />
          </div>
          <Badge 
            variant="outline" 
            className={cn("w-fit", categoryColors[term.category as keyof typeof categoryColors])}
          >
            {categoryLabels[term.category as keyof typeof categoryLabels]}
          </Badge>
        </CardHeader>
        <CardContent>
          <CardDescription className="text-sm leading-relaxed">
            {term.shortDef}
          </CardDescription>
        </CardContent>
      </Card>
    </Link>
  );
};
